export const safeParseFloat = (str: string | number): number => {
  if (!str) {
    return 0
  }
  const parsed = parseFloat(str.toString())
  if (!isNaN(parsed)) {
    return parsed
  }
  return 0
}
